// extracted by mini-css-extract-plugin
export default {"searchBox":"SearchInput_searchBox__5vBjp"};